module.exports = __webpack_public_path__ + "img/home_img_dh.c8b55322.png";